var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-details-container w-100" },
    [
      _c(
        "div",
        {
          staticClass: "col-xl-11 col-sm-11 col-12 mb-0",
          attrs: { id: "personal-details-container" },
        },
        [
          _vm.visibleField("name")
            ? _c("div", { staticClass: "row moregage-form my-lg-3 my-1" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-lg-4 d-flex align-items-center" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "bold text-light-gray font-sm mb-2 mb-lg-0",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$tc("global.words.detail", 2)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-lg-8 pb-md-0 pb-3" },
                  [
                    _c("material-input", {
                      staticClass: "position-relative",
                      attrs: {
                        label: _vm.$t("global.words.name"),
                        "hidden-label": "",
                        "required-indicator": "",
                        placeholder: _vm.$t("lists.placeholders.enterListName"),
                        name: "name",
                      },
                      model: {
                        value: _vm.name,
                        callback: function ($$v) {
                          _vm.name = $$v
                        },
                        expression: "name",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.visibleField("description")
            ? _c("div", { staticClass: "row moregage-form my-lg-3 my-1" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-lg-4 d-flex align-items-center" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "bold text-light-gray font-sm mb-2 mb-lg-0",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("global.words.description")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-lg-8" },
                  [
                    _c("material-input", {
                      attrs: {
                        label: _vm.$t("global.words.description"),
                        "hidden-label": "",
                        placeholder: _vm.$t(
                          "lists.placeholders.enterListDescription"
                        ),
                        "required-indicator": "",
                        name: "description",
                      },
                      model: {
                        value: _vm.description,
                        callback: function ($$v) {
                          _vm.description = $$v
                        },
                        expression: "description",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.visibleField("address")
            ? _c("div", { staticClass: "row moregage-form my-lg-3 my-1" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-lg-4 d-flex flex-column align-items-start",
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "bold text-light-gray font-sm mb-2 mb-lg-0",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("lists.contactInfoForThisList")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "text-primary small clickable",
                        staticStyle: { top: "20px" },
                        on: { click: _vm.handleOpenDisclaimerModal },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("global.phrases.whyDoWeAskForThis")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-lg-8 employment-wrapper" },
                  [
                    _c(
                      "material-input",
                      {
                        staticClass: "form-group-material-no-label",
                        attrs: {
                          value: _vm.companyName,
                          "custom-expression": "address.company",
                        },
                      },
                      [
                        _c("autocomplete-section", {
                          attrs: {
                            id: "company-name",
                            value: _vm.companyName,
                            name: "company",
                            placeholder: _vm.$t(
                              "application-form.employer-name-type"
                            ),
                            "class-name": "company-address",
                            label: _vm.$t(
                              "application-form.employer-name-type"
                            ),
                            "hidden-label": "",
                          },
                          on: {
                            "value-change": _vm.handleCompanyNameChange,
                            change: _vm.handleAddressChange,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("address-section", {
                      attrs: {
                        value: _vm.address,
                        title: "",
                        map: false,
                        coapp: false,
                        removable: false,
                        time: false,
                      },
                      on: { change: _vm.handleAddressChange },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("transition", { attrs: { name: "slide" } }, [
            _vm.importContacts
              ? _c("div", [
                  _c("div", { staticClass: "row moregage-form my-lg-3 my-1" }, [
                    _vm.creating
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-lg-4 d-flex flex-column align-items-start",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "bold text-gray font-sm mb-2 mb-lg-0",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$tc("lists.contact", 2)) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-8" },
                      [
                        _c("marketing-lists-contacts-choice", {
                          attrs: {
                            creating: _vm.creating,
                            "current-list": _vm.list,
                          },
                          on: { change: _vm.handleCurrentListChange },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("marketing-address-disclaimer-modal", { ref: "disclaimerModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }